module.exports = __webpack_public_path__ + "img/3-ExitusCreditContenido.9045d7db.jpg";